import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { formatDateTime } from "../lib/format";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setRows(await api.auditLogs());
      } catch (e) {
        toast.error("Accesso audit log riservato all'owner");
      } finally { setLoading(false); }
    })();
  }, []);

  const filtered = rows.filter((r) => {
    if (!filter) return true;
    const f = filter.toLowerCase();
    return (
      r.action?.toLowerCase().includes(f) ||
      r.resource_type?.toLowerCase().includes(f) ||
      r.resource_id?.toLowerCase().includes(f) ||
      r.user_id?.toLowerCase().includes(f)
    );
  });

  return (
    <section className="space-y-4" data-testid="audit-page">
      <div>
        <h2 className="font-display text-xl font-semibold">Audit</h2>
        <p className="mt-1 text-sm opacity-70 max-w-2xl">
          Registro immutabile di ogni azione sensibile: upload, estrazione, modifica campi, conferma o rifiuto, eliminazione e login.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <input
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Filtro per azione, tipo, id…"
          className="w-full sm:max-w-md rounded-full border bg-white px-4 py-2 text-sm"
          style={{ borderColor: "var(--pxos-border-strong)", color: "var(--pxos-text-dark)" }}
          data-testid="audit-filter-input"
        />
        <span className="text-xs opacity-70" data-testid="audit-count">{filtered.length}/{rows.length}</span>
      </div>

      <div className="pxos-card overflow-hidden" data-testid="audit-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-[11px] uppercase tracking-widest opacity-70" style={{ background: "var(--pxos-bg-subtle)" }}>
              <tr>
                <th className="px-4 py-3">Quando</th>
                <th className="px-4 py-3">Azione</th>
                <th className="px-4 py-3">Risorsa</th>
                <th className="px-4 py-3">Utente</th>
                <th className="px-4 py-3">IP</th>
                <th className="px-4 py-3">Meta</th>
              </tr>
            </thead>
            <tbody className="divide-y" style={{ borderColor: "var(--pxos-border)" }}>
              {loading ? (
                <tr><td colSpan={6} className="p-6 text-center opacity-70">Caricamento…</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={6} className="p-6 text-center opacity-70">Nessun evento.</td></tr>
              ) : filtered.map((r) => (
                <tr key={r.id} data-testid="audit-row">
                  <td className="px-4 py-2.5 whitespace-nowrap font-mono text-xs">{formatDateTime(r.created_at)}</td>
                  <td className="px-4 py-2.5"><span className="pxos-badge">{r.action}</span></td>
                  <td className="px-4 py-2.5 font-mono text-xs opacity-80">
                    <div>{r.resource_type}</div>
                    <div className="opacity-60 break-all">{r.resource_id}</div>
                  </td>
                  <td className="px-4 py-2.5 font-mono text-[11px] opacity-80 break-all">{r.user_id || "—"}</td>
                  <td className="px-4 py-2.5 font-mono text-xs opacity-70">{r.ip || "—"}</td>
                  <td className="px-4 py-2.5 text-xs opacity-80 max-w-[280px]">
                    {r.metadata ? <code className="text-[11px]">{JSON.stringify(r.metadata)}</code> : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
